<template>
  <div id="app" @contextmenu="handleMouse">
    <keep-alive>
      <router-view v-wechat-title="$route.meta.title" />
    </keep-alive>
    <div class="ReservationBtn" @click="toReservation" v-if="this.$route.path!='/login' && this.$route.path!='/'">立即预约</div>
      <meta name="referrer" content="never" />
    <reservation ref="child"></reservation>
  </div>
</template>

<script>
import reservation from "@/views/reservation/toReservation.vue";
export default {
  name: "App",
  components: { reservation },
  methods: {
    handleMouse(e) {
      e.preventDefault();
    },
    // 打开立即预约
    toReservation() {
      this.$refs.child.showPopup();
    },
  },
};
</script>
<style scoped>
/* .imgsty-small {
  width: 30px;
  height: 30px;
  border-radius: 50px;
  padding: 0 10px;
}
.PersonalCenter {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px;
}
.exit{
  padding: 0 0px;
  font-size: 14px;
  color: #409EFF;
  border-bottom: 1px solid #409EFF;
  cursor: pointer;
}
.exit:hover{
  padding: 0 0px;
  font-size: 14px;
  color: red;
  border-bottom: 1px solid red;
  cursor: pointer;
} */
</style>
<style>
/* 去掉滚动条 */
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;height: 0;
}
.ReservationBtn {
  width: 24px;
  height: 95px;
  background: #d22424;
  color: white;
  text-align: center;
  padding-top: 6px;
  border-radius: 3px;
  position: fixed;
  top: 60%;
  right: 0;
  cursor: pointer;
  z-index: 99;
}

/* ::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #c0c0c0;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 5px;
} */
.el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
 
.el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
}
</style>
